export const countData = {
  SET_COUNT_DATA: "SET_COUNT_DATA",
};
